import React, { useEffect, useState } from "react";
import {
  Layers,
  ChevronDown,
  MapPin,
  Satellite,
  Mountain,
  CarFrontIcon,
  Map,
} from "lucide-react";

interface MapControlsProps {
  mapType: string;
  showTraffic: boolean;
  onMapTypeChange: (mapType: string) => void;
  onTrafficToggle: (showTraffic: boolean) => void;
}

const MapControls: React.FC<MapControlsProps> = ({
  mapType,
  showTraffic,
  onMapTypeChange,
  onTrafficToggle,
}) => {
  const [showMapTypeDropdown, setShowMapTypeDropdown] = useState(false);

  const handleMapTypeSelect = (type: string) => {
    onMapTypeChange(type);
    setShowMapTypeDropdown(false);
  };

  const handleTrafficToggle = () => {
    onTrafficToggle(!showTraffic);
  };

  useEffect(() => {
    if (!localStorage.getItem("showTraffic")) return;
    const isTraffic = JSON.parse(localStorage.getItem("showTraffic") || "");
    onTrafficToggle(isTraffic);
  }, []);

  useEffect(() => {
    localStorage.setItem("showTraffic", JSON.stringify(showTraffic));
  }, [showTraffic]);

  return (
    <>
      {/* Dropdown options */}
      {showMapTypeDropdown && (
        <div className="bg-white rounded-sm shadow-md border absolute bottom-10 left-0 z-10 border-gray-200 p-1 flex flex-col gap-1">
          <button
            onClick={() => handleMapTypeSelect("roadmap")}
            className={`p-2 rounded hover:bg-gray-50 transition-colors flex items-center justify-center ${
              mapType === "roadmap"
                ? "bg-blue-50 text-blue-600"
                : "text-gray-700"
            }`}
            title="Map"
          >
            <MapPin className="w-4 h-4" />
          </button>
          <button
            onClick={() => handleMapTypeSelect("green")}
            className={`p-2 rounded hover:bg-gray-50 transition-colors flex items-center justify-center ${
              mapType === "green" ? "bg-blue-50 text-blue-600" : "text-gray-700"
            }`}
            title="Green Map"
          >
            <Map className="w-4 h-4" />
          </button>
          <button
            onClick={() => handleMapTypeSelect("satellite")}
            className={`p-2 rounded hover:bg-gray-50 transition-colors flex items-center justify-center ${
              mapType === "satellite"
                ? "bg-blue-50 text-blue-600"
                : "text-gray-700"
            }`}
            title="Satellite"
          >
            <Satellite className="w-4 h-4" />
          </button>
          <button
            onClick={() => handleMapTypeSelect("hybrid")}
            className={`p-2 rounded hover:bg-gray-50 transition-colors flex items-center justify-center ${
              mapType === "hybrid"
                ? "bg-blue-50 text-blue-600"
                : "text-gray-700"
            }`}
            title="Hybrid"
          >
            <Layers className="w-4 h-4" />
          </button>
          <button
            onClick={() => handleMapTypeSelect("terrain")}
            className={`p-2 rounded hover:bg-gray-50 transition-colors flex items-center justify-center ${
              mapType === "terrain"
                ? "bg-blue-50 text-blue-600"
                : "text-gray-700"
            }`}
            title="Terrain"
          >
            <Mountain className="w-4 h-4" />
          </button>

          {/* Traffic Toggle inside dropdown */}
          <div className="border-t border-gray-200 my-1"></div>
          <button
            onClick={handleTrafficToggle}
            className={`p-2 rounded hover:bg-gray-50 transition-colors flex items-center justify-center ${
              showTraffic ? "bg-blue-50 text-blue-600" : "text-gray-700"
            }`}
            title="Traffic"
          >
            <CarFrontIcon className="w-4 h-4" />
          </button>
        </div>
      )}
      <div className="relative bg-white rounded-sm shadow-md border border-gray-300">
        {/* Main layer button */}
        <button
          onClick={() => setShowMapTypeDropdown(!showMapTypeDropdown)}
          className="p-2 rounded hover:bg-gray-50 transition-colors flex items-center justify-center gap-1 text-gray-700"
          title="Map Layers"
        >
          <Layers className="w-4 h-4" />
          <ChevronDown
            className={`w-3 h-3 transition-transform ${
              showMapTypeDropdown ? "rotate-180" : ""
            }`}
          />
        </button>
      </div>
    </>
  );
};

export default MapControls;
